import { paramCase } from "change-case";
import {of as toCSS} from 'json-to-css';

export function jsonToCSS(source) {
    let style = {};
    for (let selector in source) {
        let convertedStyle = {};
        for (let propName in source[selector]) {
            convertedStyle[paramCase(propName)] = source[selector][propName];
        }
        style[selector] = convertedStyle;
    }
    return toCSS(style);
}
